// extracted by mini-css-extract-plugin
var _1 = "buttons--QGqglen4";
var _2 = "panel--LUUqchCz";
export { _1 as "buttons", _2 as "panel" }
